<template>
  <el-select v-model="tempData" placeholder="请选择" @change="change" :style="`width: ${width}`" :disabled="disabled" :clearable="clearable" filterable>
    <el-option v-for="item in list" :label="item" :value="item" :key="item"></el-option>
  </el-select>
</template>

<script>
  export default {
    name: "DeviceBatchSelect",
    model: {
      event: 'change',
    },
    props: {
      clearable: {
        type: Boolean,
        default: false,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      width: {
        type: String,
        default: "100%",
      },
      prop: {
        type: String,
        default: "id",
      },
      value: [String, Number],
    },
    data() {
      return {
        tempData: this.value,
        list: []
      }
    },
    watch: {
      value(val) {
        this.tempData = val;
      }
    },
    created() {
      this.getList();
    },
    methods: {
      async getList() {
        let res = await this.$Http.getDeviceBatchOption({
          mode: "batch"
        });
        if (res?.data) {
          this.list = res.data || [];
        }
      },
      change(val) {
        this.$emit('change', val)
      }
    }
  }
</script>

<style scoped>

</style>
